// TODO make some more appropriated guesses logic?
var scoring = (() => {
  return 1;
});

export { scoring as default };
//# sourceMappingURL=scoring.esm.js.map
